import { createReducer } from '@reduxjs/toolkit';
import { getLaboratoryPage } from '../actions/laboratoryPage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getLaboratoryPage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
